const LineHalf = () => {
	return <div className='line-half'></div>
}

export default LineHalf
